module.exports = __webpack_public_path__ + "static/media/vijftigplus.c42c0b61.png";